import * as React from 'react';
import TextHelper from '../../../../../../../../core/helpers/TextHelper';
import { Block } from '../../../../../../../components';
import Select from '../../../../../components/Select';
import constants from '../../../../../constants';
import { ActionableButton } from '../../info/components';
import RegisterDataUser from './RegisterDataUser';

interface RegisterFormProps {
  isValid: boolean;
  periods: any[];
  changePeriod: (period: any) => void;
  onSubmit: () => void;
  admission: any;
  procedureId: number;
}

const RegisterForm: React.FC<RegisterFormProps> = (props) => {
  const { isValid, periods, changePeriod, onSubmit, procedureId, admission } =
    props;
  return (
    <Block
      customized
      padding="24px"
      backgroundColor="#fff"
      borderRadius="4px"
      margin="16px 0px 32px 0px"
    >
      {procedureId !== constants.categories.certificates.type1Ids[1] &&
      procedureId !== constants.categories.certificates.type1Ids[4] &&
      procedureId !== constants.categories.certificates.type1Ids[6] ? (
        <Select
          options={periods}
          placeholder="Elige un ciclo"
          handleChangeSelect={changePeriod}
        />
      ) : (
        <RegisterDataUser
          onClick={onSubmit}
          period={admission?.periodDesc}
          periodId={admission?.periodId}
          career={TextHelper.capitalize(admission?.program)}
          handleSetDefaultSelect={changePeriod}
          weightedAverage={admission?.weightedAverage}
          hasDebts={admission?.hasDebts}
        />
      )}
      <ActionableButton
        text="Siguiente"
        marginTop={24}
        enabled={
          isValid ||
          procedureId === constants.categories.certificates.type1Ids[1] ||
          procedureId === constants.categories.certificates.type1Ids[4] ||
          procedureId === constants.categories.certificates.type1Ids[6]
        }
        onClick={onSubmit}
      />
    </Block>
  );
};

export default RegisterForm;
